<template>
  <div class="pageContol listWrap templateList templateList1">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">消息管理</a>
          <i>></i>
          <a href="javascript:;" @click="goback">系统公告</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">公告详情</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <div class="contentNotification">
              <h1 style="width:100%;padding-bottom:30px;text-align:center">{{comment.noticeTitle}}</h1>
              <div class="detail">
                <div v-html="comment.noticeDetail"></div>
              </div>
              <el-button
                v-if="comment.attachmentUrl"
                type="text"
                size="mini"
                style="color:#FE2120;text-align:left;font-size:16px;margin-top:10px"
                @click="
                  downloadTrainDocument()
                "
              >
                <i class="el-icon-document-remove"></i> 预览附件
              </el-button>
              <!-- <p align="right">{{comment.createTime|moment}}</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="下载培训档案"
      :visible.sync="dialogDownload"
      width="50%"
      top="15px"
      center
      :before-close="closeDownloadTrainDocument"
    >
      <div id="pdf-content" style="height: 800px"></div>
    </el-dialog>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import List from "@/mixins/List";
import moment from "moment";
import pdf from "pdfobject";
export default {
  name: "noticationDetail",
  components: {},
  data() {
    return {
      comment: "",
      dialogDownload: false
    };
  },
  mixins: [List],
  created() {
    this.getDetail();
  },
  methods: {
    goback(){
       this.$router.push({
        path: "/web/systemNotication",
       
      });
    },
    getDetail() {
      this.$post("/notice/selectByNoticeDetails", {
        noticeId: this.$route.query.noticeId
      }).then(res => {
        let retData = res.data || {};
        this.comment = retData;
      });
    },
    downloadTrainDocument() {
      // let parmar = {
      //   projectId: projectId,
      //   userId: userId
      // };
      this.dialogDownload = true;
      this.$nextTick(() => {
        pdf.embed(this.comment.attachmentUrl, "#pdf-content");
      });

      // this.$post("/cert/downloadTrainDocument", parmar).then(res => {
      //   if (res.status == 0) {
      //     this.dialogDownload = true;
      //     this.$nextTick(() => {
      //       pdf.embed(res.data, "#pdf-content");
      //     });
      //   } else {
      //     that.$message.warning({ message: res.message, duration: 1500 });
      //   }
      // });
    }
  }
};
</script>

<style lang="less">
.framePage-body {
  .contentNotification {
    padding: 30px;
    p {
      text-indent:0 !important;
      width: 100% !important;
      margin-bottom: 15px !important;
      // span {
      //   // text-indent: 20px !important;
      // }
    }
  }
}
</style>
